import { Cookies } from 'react-cookie';

import { AddTrapToObjectRequest } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const addMultiTrapToObject = async (info: { addData: AddTrapToObjectRequest; slug: string }) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const formData = new FormData();
  if (info.addData.installment_picture) {
    formData.append('installment_picture', info.addData.installment_picture as Blob);
  }
  formData.append('hub', info.addData.hub || '');
  formData.append('trap', info.addData.trap);
  formData.append('sequence_number', String(info.addData.sequence_number));
  formData.append('date_of_installation', info.addData.date_of_installation);
  formData.append('recomended_bait_filling', String(info.addData.recomended_bait_filling));

  formData.append('installment_comment', info.addData.installment_comment || '');
  const data = await axiosInterceptor.post(`/traps/${info.slug}/add-trap-on-object/`, formData, {
    headers: {
      Authorization: token,
      'Content-Type': 'multipart/form-data',
    },
  });

  return data.data as any;
};
